import { Link } from "react-router-dom";
import PageCTA from "@/components/PageCTA";

const PolitykaPrywatnosci = () => (
  <div className="min-h-screen" data-testid="polityka-page">
    <div className="bg-[var(--color-black)]" style={{ paddingTop: 100, paddingBottom: 40 }}>
      <div className="container">
        <div className="flex items-center gap-2 text-xs font-body text-[var(--color-text-light-muted)] mb-6">
          <Link to="/" className="hover:text-[var(--color-gold)] transition-colors">Strona główna</Link>
          <span>/</span>
          <span className="text-[var(--color-text-light)]">Polityka prywatności</span>
        </div>
        <h1 className="font-heading text-[clamp(36px,5vw,52px)] text-[var(--color-text-light)]">
          Polityka prywatności
        </h1>
      </div>
    </div>

    <div className="section bg-[var(--color-cream)]">
      <div className="container max-w-3xl mx-auto">
        <div className="font-body text-[var(--color-text-muted)] leading-relaxed space-y-8">
          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">1. Administrator danych</h2>
            <p>Administratorem danych osobowych jest ApisDesign, kontakt: <a href="mailto:aml01@vp.pl" className="text-[var(--color-gold)] hover:underline">aml01@vp.pl</a>, tel. <a href="tel:+48507334540" className="text-[var(--color-gold)] hover:underline">+48 507 334 540</a>.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">2. Jakie dane zbieramy</h2>
            <p>Za pośrednictwem formularza kontaktowego zbieramy:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>imię i nazwisko,</li>
              <li>adres e-mail,</li>
              <li>numer telefonu (opcjonalnie),</li>
              <li>treść wiadomości.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">3. Cel przetwarzania danych</h2>
            <p>Dane osobowe przetwarzane są w celu:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>odpowiedzi na zapytania przesłane przez formularz kontaktowy,</li>
              <li>realizacji zamówionych usług,</li>
              <li>wystawiania faktur i rozliczeń,</li>
              <li>kontaktu w sprawie realizacji projektu.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">4. Podstawa prawna</h2>
            <p>Przetwarzanie danych odbywa się na podstawie art. 6 ust. 1 lit. a, b i f RODO — zgoda, realizacja umowy oraz prawnie uzasadniony interes administratora.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">5. Okres przechowywania</h2>
            <p>Dane przechowywane są przez okres niezbędny do realizacji usługi oraz przez okres wymagany przepisami prawa (np. dokumentacja księgowa — 5 lat).</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">6. Prawa użytkownika</h2>
            <p>Masz prawo do:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>dostępu do swoich danych,</li>
              <li>sprostowania danych,</li>
              <li>usunięcia danych,</li>
              <li>ograniczenia przetwarzania,</li>
              <li>przenoszenia danych,</li>
              <li>wniesienia sprzeciwu,</li>
              <li>cofnięcia zgody w dowolnym momencie.</li>
            </ul>
            <p className="mt-3">W celu realizacji powyższych praw prosimy o kontakt: <a href="mailto:aml01@vp.pl" className="text-[var(--color-gold)] hover:underline">aml01@vp.pl</a>.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">7. Pliki cookies</h2>
            <p>Strona apisdesign.pl może wykorzystywać pliki cookies w celu zapewnienia prawidłowego działania oraz analizy ruchu. Użytkownik może zarządzać ustawieniami cookies w przeglądarce.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-medium text-[var(--color-text-dark)] mb-4">8. Zmiany polityki</h2>
            <p>ApisDesign zastrzega sobie prawo do zmiany polityki prywatności. Aktualna wersja jest zawsze dostępna na stronie.</p>
          </section>
        </div>
      </div>
    </div>
  </div>
);

export default PolitykaPrywatnosci;
